// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__2ue6w","title":"Navbar_title__y71nW","logo":"Navbar_logo__-a2hD"};